<template>
  <div
    class="max-w-sm rounded-sm bg-white shadow-xl shadow-gray-500/40"
    data-cy="funding-advisor-details"
  >
    <div class="space-y-2 p-4 text-gray-600">
      <template v-if="fundingAdvisorDetails.name">
        <span class="flex w-full items-center space-x-4 text-inherit">
          <span class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-500">
            <icon-advisor class="text-white" />
          </span>
          <span class="flex flex-col">
            <span>{{ fundingAdvisorDetails.name }}</span>
            <span class="text-xs text-gray-400">{{ $t("role.fundingAdvisor") }}</span>
          </span>
        </span>
        <hr class="border" />
      </template>
      <template v-if="fundingAdvisorDetails.telephone">
        <a
          :href="`tel:${fundingAdvisorDetails.telephone}`"
          class="flex w-full items-center space-x-4 text-inherit hover:underline"
          @click="trackFundingAdvisorContactedEvent"
        >
          <icon-phone class="text-gray-500" />
          <span>{{ fundingAdvisorDetails.telephone }}</span>
        </a>
        <hr class="border" />
      </template>
      <a
        v-if="fundingAdvisorDetails.calendarLink"
        :href="fundingAdvisorDetails.calendarLink"
        class="flex w-full items-center space-x-4 hover:underline"
        target="_blank"
        rel="noopener noreferrer"
        @click="trackFundingAdvisorContactedEvent"
      >
        <icon-calendar />
        <span>{{ $t("profile.calendar_link") }}</span>
      </a>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconPhone from "@/components/icons/IconPhone.vue";
import IconAdvisor from "@/components/icons/IconAdvisor.vue";
import IconCalendar from "@/components/icons/IconCalendar.vue";
import * as amplitude from "@amplitude/analytics-browser";
import useApplicationsState from "@/composables/state/applicationsState";
import type { FundingAdvisor } from "@/api/http/schemas/applicationSchemas";
import { computed } from "vue";
import { useResponsive } from "@/composables/common";

const props = defineProps<{
  advisor: FundingAdvisor;
}>();

const { selectedApplication } = useApplicationsState();
const { isMobile } = useResponsive();

const fundingAdvisorName = computed(() => `${props.advisor.first_name} ${props.advisor.last_name}`);

const fundingAdvisorDetails = computed(() => {
  const { telephone, calendar_link } = props.advisor;
  return {
    name: isMobile ? fundingAdvisorName.value : "",
    telephone: telephone || "",
    calendarLink: calendar_link || "",
  };
});

const trackFundingAdvisorContactedEvent = () => {
  amplitude.track("Funding Advisor Contacted", {
    "Application ID": selectedApplication.value?.id ?? "",
    "Funding Advisor Name": fundingAdvisorName.value,
  });
};
</script>
